import React, { Component } from 'react';
import Form from '../../models/Form';
import FormCategory from '../../models/FormCategory';
import Language from '../../models/Language';
import SearchBar from '../../../../views/components/SearchBar.Component';
import FormListItem from '../components/FormListItem.Component';
import FormsService from '../../services/Forms.service';

declare var dataLayer: any;

type FormsOverviewPageProps = {
    overviewID: number,
    labels: any,
    region: string,
}

type FormsOverviewPageState = {
    forms: Form[]
    categories: FormCategory[],
    languages: Language[],
    keyword: string,
}

export default class FormsOverviewPage extends Component<FormsOverviewPageProps, FormsOverviewPageState> {
    constructor(props: FormsOverviewPageProps) {
        super(props);

        this.state = {
            forms: [],
            categories: [],
            languages: [],
            keyword: "",
        };
    }


    public async categorySelectionChanged(category: FormCategory) {
        const categories = this.state.categories;
        categories.filter(cat => cat.id === category.id)[0].selected != category.selected;

        for (var cat of categories) {
            if (cat.id === category.id) {
                cat.selected = !category.selected;
            }
        }

        const forms: Form[] = await this.getForms(this.state.keyword, this.state.languages.filter(lang => lang.selected), categories.filter(cat => cat.selected));

        this.setState({
            forms: forms,
            categories: categories
        })
    }

    public async filterOneCategory(category: FormCategory) {
        const categories = this.state.categories;

        for (var cat of categories) {
            if (cat.id === category.id) {
                cat.selected = true;
            }
            else {
                cat.selected = false;
            }
        }

        const forms: Form[] = await this.getForms(this.state.keyword, this.state.languages.filter(lang => lang.selected), categories.filter(cat => cat.selected));

        this.setState({
            forms: forms,
            categories: categories
        })
    }

    public async languageSelectionChanged(language: Language) {
        const languages = this.state.languages;

        for (var lang of languages) {
            if (lang.code === language.code) {
                lang.selected = !language.selected;
            }
        }

        const forms: Form[] = await this.getForms(this.state.keyword, languages.filter(lang => lang.selected), this.state.categories.filter(cat => cat.selected));

        this.setState({
            forms: forms,
            languages: languages
        })
    }

    public async filterOneLanguage(language: Language) {
        const languages = this.state.languages;

        for (var lang of languages) {
            if (lang.code === language.code) {
                lang.selected = true;
            }
            else {
                lang.selected = false;
            }
        }

        const forms: Form[] = await this.getForms(this.state.keyword, languages.filter(lang => lang.selected), this.state.categories.filter(cat => cat.selected));

        this.setState({
            forms: forms,
            languages: languages
        })
    }

    public async searchForms(keyword: string) {
        const forms: Form[] = await this.getForms(keyword, this.state.languages.filter(lang => lang.selected), this.state.categories.filter(cat => cat.selected));

        this.setState({
            forms: forms,
            keyword: keyword
        })
    }

    private async getForms(keyword: string, languages: Language[], categories: FormCategory[]): Promise<Form[]> {
        const service: FormsService = new FormsService();

        const selectedCategoryIDs: string[] = [];
        const selectedLanguages: string[] = [];

        for (var cat of categories) {
            selectedCategoryIDs.push(cat.id);
        }

        for (var lang of languages) {
            selectedLanguages.push(lang.code);
        }

        const forms: Form[] = await service.getForms(keyword, this.props.overviewID, this.props.region, selectedLanguages, selectedCategoryIDs);

        return forms;
    }

    public async componentDidMount() {
        const service: FormsService = new FormsService();

        const categories: FormCategory[] = await service.getCategories(this.props.overviewID, this.props.region);
        const languages: Language[] = await service.getLanguages(this.props.overviewID);
        const forms: Form[] = await this.getForms(this.state.keyword, languages.filter(lang => lang.selected), categories.filter(cat => cat.selected));

        this.setState({
            forms: forms,
            categories: categories,
            languages: languages
        })
    }

    public render() {
        return (

            <div className="container mt-5 mb-5">
                <div className="mb-5">
                    <SearchBar onSearch={(keyword: string) => { this.searchForms(keyword) }} searchButtonText={this.props.labels["searchbutton"]} placeholderText={this.props.labels["searchPlaceholder"]} />
                </div>
                <div className="row pt-4">
                    <div className="col-lg-4">
                        <div className="text-uppercase small font-weight-bold letter-spacing-large text-brown-100 mb-4">{this.props.labels["filterTitle"]}</div>
                        <div className="card bg-white border-radius card-slope-bottom p-4">
                            <span className="font-weight-bold text-medium">{this.props.labels["languageFilterTitle"]}</span>
                            {
                                this.state.languages.map((language: Language, index: number) => {
                                    return (
                                        <div className="custom-control custom-checkbox" key={'form-language-' + index}>
                                            <input type="checkbox" className="custom-control-input" checked={language.selected} id={"category" + language.code} onChange={() => { this.languageSelectionChanged(language); }} />
                                            <label className="custom-control-label" htmlFor={"category" + language.code}>{language.name}</label>
                                        </div>
                                    )
                                })
                            }
                            <hr className="border-brown-10" />
                            <span className="font-weight-bold text-medium">{this.props.labels["categoryFilterTitle"]}</span>
                            {
                                this.state.categories.map((category: FormCategory, index: number) => {
                                    return (
                                        <div className="custom-control custom-checkbox" key={'form-category-' + index}>
                                            <input type="checkbox" className="custom-control-input" checked={category.selected} id={"category" + category.id} onChange={() => { this.categorySelectionChanged(category); }} />
                                            <label className="custom-control-label" htmlFor={"category" + category.id}>{category.name}</label>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="col-lg">
                        <h2 className='sr-only' aria-live='polite'>{this.state.forms.length + " " + this.props.labels["numberOfResultsFoundLabel"]}</h2>

                        {
                            this.state.forms.map((form: Form, index: number) => {
                                return (
                                    <div key={'form' + index}>
                                        <FormListItem form={form} downloadAltLabel={this.props.labels["downloadAltLabel"]} onlineLinkLabel={this.props.labels["OnlineLinkLabel"]} categorySelected={(category: FormCategory) => { this.filterOneCategory(category); }} languageSelected={(language: Language) => { this.filterOneLanguage(language); }} />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}